import { Box, Stepper, Step, StepLabel, Tooltip, useTheme, useMediaQuery, Typography, Divider } from "@mui/material";
import { CleaningServices, Summarize, CheckCircle } from "@mui/icons-material";
import { cloneElement } from "react";
import { useSelector } from "react-redux";
import { colors } from "../../../../ui/colors";
import { selectStep } from "../../../../../redux/features/quotes/quote-create-advanced/selectors/navigationSelectors";

const steps = [
  {
    id: "sector",
    name: "Define Services",
    icon: <CleaningServices />,
    description: "Select the specific services to be provided.",
  },
  {
    id: "summary",
    name: "Summary",
    icon: <Summarize />,
    description: "Review and confirm your quote before submission.",
  },
];

export const QuoteCreateStepper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const stepQuote = useSelector(selectStep);
  const currStep = steps.findIndex((s) => s.id === stepQuote);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        // mx: "138px",
        my: 2,
        px: { xs: 1, sm: 2, md: 0 },
        overflowX: { xs: "auto", sm: "visible" },
      }}
    >
      <Stepper
        activeStep={currStep}
        alternativeLabel={!isMobile}
        orientation={isMobile ? "vertical" : "horizontal"}
        sx={{
          bgcolor: "transparent",
          px: isMobile ? 0 : 2,
          "& .MuiStepConnector-line": {
            borderColor: colors.orange[200],
            borderWidth: 2,
          },
          "& .MuiStep-root": {
            flex: isMobile ? "1 1 auto" : "1 1 0",
            minWidth: isMobile ? "auto" : 0,
          },
        }}
      >
        {steps.map((step, index) => {
          const completed = currStep > index;
          const isActive = currStep === index;

          const Icon = completed ? <CheckCircle sx={{ fontSize: "1.25rem" }} /> : cloneElement(step.icon, { sx: { fontSize: "1.25rem" } });

          return (
            <Step key={step.id} completed={completed}>
              <Tooltip title={step.description} arrow>
                <StepLabel
                  StepIconComponent={() => (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        bgcolor: completed ? colors.orange[100] : isActive ? colors.orange.base : colors.gray[100],
                        color: completed ? colors.orange.base : isActive ? "#fff" : colors.gray[400],
                        border: `2px solid ${completed ? colors.orange[300] : isActive ? colors.orange.base : colors.gray[200]}`,
                        transition: "all 0.2s ease",
                      }}
                    >
                      {Icon}
                    </Box>
                  )}
                  sx={{
                    mt: isMobile ? 0 : 1,
                    textAlign: "center",
                    "& .MuiStepLabel-label": {
                      typography: isMobile ? "body2" : "caption",
                      mt: 1,
                      color: isActive ? colors.orange.base : completed ? colors.gray[600] : colors.gray[400],
                      fontWeight: isActive || completed ? 600 : 400,
                    },
                  }}
                >
                  <Typography variant={isMobile ? "body2" : "caption"} noWrap>
                    {step.name}
                  </Typography>
                </StepLabel>
              </Tooltip>
            </Step>
          );
        })}
      </Stepper>

      <Divider sx={{ mt: 2, maxWidth: 1200, marginLeft: "-78px" }} />
    </Box>
  );
};
